import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { IncluirTipoDocumentalComponent } from "app/incluir-tipo-documental/incluir-tipo-documental.component";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { EditarAspectoComponent } from "app/editar-aspecto/editar-aspecto.component";
import { MatTableDataSource, MatPaginator, MatSort } from "@angular/material";
import { AuthenticationService } from "@alfresco/adf-core";
import { AreaService } from "app/service/cliente/area.service";
import { ClienteService } from "app/service/cliente/cliente.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";
import { NodeEditDialogComponent } from "app/components/dialog/node-edit-dialog/node-edit-dialog.component";

@Component({
  selector: "app-vincular-tipo-cliente",
  templateUrl: "./vincular-tipo-cliente.component.html",
  styleUrls: ["./vincular-tipo-cliente.component.scss"],
})
export class VincularTipoClienteComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private arrayString: string;
  authorityUser = [];
  userId: number;
  public tipoEditor = false;
  public superUser = false;
  public superUserGeneral = false;

  clienteId: number;
  tiposDocumentais: any[];
  tiposDocumentaisAdd: any[];
  nameEmpresa;
  nomeArea;
  nomeAreaBoolean = false;
  nomeAreaBooleanAll = false;
  areas: any[];
  areaPesquisada;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  loading = false;
  displayedColumns = [
    "tpDocumental",
    "area",
    "name",
    "descricao",
    "aspectos",
    "acoes",
  ];
  dataSource = new MatTableDataSource<any[]>([]);
  typeSelectedId: number;

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private permissoesService: PermissoesService,
    private service: ConfigurarPastaServiceService,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    private areaSerice: AreaService,
    private authService: AuthenticationService,
    private router: Router
  ) {
    this.route.params.subscribe((params) => (this.clienteId = params["id"]));

    this.getPermissionCliente(this.clienteId);
    //this.listarTiposAdd();
  }

  ngOnInit() {
    this.listarAreas();
    this.listarNomeEmpresa();

    //listen node edited or created
    this.service.isChangedNode.subscribe(() => {
      if(this.areaPesquisada) {
        this.search(this.areaPesquisada);
      }
    });
  }

  getPermissionCliente(idCliente: number) {
    this.loading = true;
    this.authorityUser = [];
    //permissões por usuario
    this.permissoesService
      .getPermissionsInUserLogged()
      .subscribe((data: any[]) => {
        this.authorityUser = data.map((el) => el.name);
        this.getAuthorityUser();
      });
    //permissões por cliente
    this.permissoesService.getPermissionEmpresa(idCliente).subscribe(
      (data) => {
        const arrayAuthorityCliente: any[] = [];
        data.forEach((el) => {
          arrayAuthorityCliente.push(el.authority);
        });
        this.permissoesService.setItemAuthority(
          "authority-Empresa",
          arrayAuthorityCliente
        );
        this.getAuthorityEmpresa();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        console.error(err);
        this.openSnackBarError("Ocorreu um erro, tente novamente mais tarde");
      }
    );
  }

  getAuthorityEmpresa() {
    this.arrayString =
      this.permissoesService.getItemAuthority("authority-Empresa");
    if (this.arrayString.includes("EDIT_TIPO")) {
      this.tipoEditor = true;
    }
    if (this.arrayString.includes("SUPER_USER")) {
      this.superUser = true;
    }
  }

  getAuthorityUser() {
    if (this.authorityUser.includes("SUPER_USER")) {
      this.superUserGeneral = true;
    }
  }

  getNodeClienteArea(clienteId, areaId) {
    this.service.getNodeClienteArea(clienteId, areaId).subscribe(
      (data) => {
        if (data.length === 0) {
          this.openSnackBarError("Nenhum Tipo Documental associado !");
          this.tiposDocumentais = null;
          this.dataSource = new MatTableDataSource(null);
          this.loading = false;
        } else {
          this.dataSource = new MatTableDataSource(data);
          this.dataSource.paginator = this.paginator;
          this.paginator._pageIndex = 0;
          this.dataSource.sort = this.sort;
          this.tiposDocumentais = data;
          this.loading = false;
        }
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  getNodeClienteAllAreas(clienteId) {
    this.service.getTiposByClienteAllArea(clienteId).subscribe(
      (data) => {
        if (data.length === 0) {
          this.openSnackBarError("Nenhum Tipo Documental associado !");
          this.tiposDocumentais = null;
          this.dataSource = new MatTableDataSource(null);
          this.loading = false;
        } else {
          this.dataSource = new MatTableDataSource(data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.tiposDocumentais = data;
          this.loading = false;
        }
      },
      (err) => {
        this.loading = false;
        console.error(err);
      }
    );
  }

  search(e) {
    this.loading = true;
    this.areaPesquisada = e;
    if (e === -1) {
      this.nomeAreaBoolean = false;
      this.nomeAreaBooleanAll = true;
      this.getNodeClienteAllAreas(this.clienteId);
    }
    if (e == 0) {
      this.openSnackBarError("Selecione uma área para realizar a listagem !");
      this.tiposDocumentais = null;
      this.dataSource = new MatTableDataSource(null);
      this.loading = false;
    }
    if (e > 0) {
      this.nomeAreaBooleanAll = false;
      this.nomeAreaBoolean = true;
      this.getNodeClienteArea(this.clienteId, e);
      var result = this.areas.filter((obj) => {
        return obj.id === e;
      });

      this.nomeArea = result[0].descricao;
    }
  }

  listarAreas() {
    this.areaSerice.getDescricaoAreasCliente(this.clienteId).subscribe(
      (data) => {
        this.areas = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarNomeEmpresa() {
    this.clienteService.nomeCliente(this.clienteId).subscribe(
      (data) => {
        this.nameEmpresa = data;
      },
      (err) => {
        console.error(err);
        this.nameEmpresa = err.error.text;
      }
    );
  }

  listarTiposAdd() {
    this.service.getTiposByCliente(this.clienteId).subscribe(
      (data) => {
        this.tiposDocumentaisAdd = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  incluirTipoDocumental() {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(IncluirTipoDocumentalComponent, {
      // , itensIncluidos : this.tiposDocumentaisAdd
      data: { dataDialog: this.clienteId },
      width: largura,
    });

    dialogRef.afterClosed().subscribe((result) => {
      // this.getNodeClienteArea(this.clienteId, result);
    });
  }

  openNodeEditDialog(node?) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(NodeEditDialogComponent, {
      data: { clientId: this.clienteId, node },
      width: largura,
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        console.log(result)
      },
      (err) => {
        this.openSnackBarError(
          "Ocorreu um erro, tente novamente em alguns instantes"
        );
      }
    );
  }

  setTypeSelected(id) {
    this.typeSelectedId = id;
  }

  deleteNode() {
    console.log(this.typeSelectedId);

    this.service.deleteNode(this.typeSelectedId).subscribe((data) => {
      console.log(data);
      this.openSnackBarSuccess('Tipo Documental excluido com sucesso');

      this.search(this.areaPesquisada);
    }, err => {
      this.openSnackBarError('Não foi possível excluir o tipo documental');
      console.log(err);
    })
  }

  goToEditAspects(tipoId) {
    this.router.navigate(["/edit-aspectos", this.clienteId, tipoId]);
  }

  goToManterAspectos() {
    this.router.navigate(["/manter-aspecto", this.clienteId]);
  }

  goToEditProperties(tipoId) {
    localStorage.setItem('ROUTER_PROP', 'not_global_type');
    this.router.navigate(["/edit-properties", this.clienteId, tipoId]);
  }

  goToTemporalidade(tipoId) {
    sessionStorage.setItem('clienteId', this.clienteId.toString());
    this.router.navigate(['/temporalidade/', tipoId]);
  }

  visualizarAspectos(item) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }
    const dialogRef = this.dialog.open(EditarAspectoComponent, {
      data: {
        dataDialog: item,
        clienteId: this.clienteId,
        isSuperUser: this.superUser,
      },
      width: largura,
    });
  }

  goToArquivistico(tipoId) {
    this.router.navigate([`dados-arquivisticos/${this.clienteId}/${tipoId}`]);
  }

  navigateToUsersAuth() {
    this.router.navigate([`/set-users-by-documental-type/${this.clienteId}`]);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/vincular-tipo-cliente/vincular-tipo-cliente.component.ts